'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import RevealHome from '../fx/RevealHome.js';
import gsap from 'gsap'
import SplitText  from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);
import lottie from 'lottie-web'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--page'
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 200);
    }

    intro()
    {
      const $intro = this.view.querySelector('.jsIntro')
      const $elements = [$intro.querySelector('.fxLogo'),$intro.querySelector('.fxText'),this.view.querySelector('.fxTextDesc')]

      const tl = gsap.timeline()

      tl.add([
        gsap.fromTo($elements , { autoAlpha : 0 , y : 10 } , { autoAlpha : 1 , y : 0, ease : 'power4.out' , duration:1, stagger:.2 }),
      ])

    }
}

page = Barba.BaseView.extend({
    namespace: 'page',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
